"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submittedClaimSchema = void 0;
var borrower_charges_1 = require("./borrower-charges");
var borrower_details_1 = require("./borrower-details");
var constants_1 = require("../constants");
var default_management_1 = require("./default-management");
var detail_1 = require("./detail");
var indicator_1 = require("./indicator");
var lender_1 = require("./lender");
var net_operating_income_rental_income_1 = require("./net-operating-income-rental-income");
var partial_payment_1 = require("./partial-payment");
var property_1 = require("./property");
exports.submittedClaimSchema = {
    type: 'object',
    required: [
        'approvedLenderFinancialInstitutionCode',
        'approvedLenderReferenceNumber',
        'approvedLenderTransitNumber',
        'claimBusinessID',
        'claimTypeIndicator',
        'cmhcLoanAccountNumber',
        'partialPaymentReceived',
        'rentalIncomeReceived',
        'lender',
        'borrowers',
        'property',
        'defaultManagement',
        'detail',
        'borrowerCharges',
    ],
    properties: {
        approvedLenderFinancialInstitutionCode: {
            type: 'string',
            minLength: 3,
            maxLength: 3,
            errorMessage: 'Should be a string with 3 characters',
        },
        approvedLenderReferenceNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 20,
            errorMessage: 'Should be a string with a maximum of 20 characters',
        },
        approvedLenderTransitNumber: {
            type: 'string',
            minLength: 5,
            maxLength: 5,
            errorMessage: 'Should be a string with 5 characters',
        },
        claimBusinessID: {
            type: 'string',
            minLength: 0,
            maxLength: 30,
            errorMessage: 'Should be a string with a maximum of 30 characters',
        },
        claimTypeIndicator: {
            type: 'number',
            enum: Object.values(constants_1.ClaimTypeIndicator),
            errorMessage: 'Should equate to a valid ClaimTypeIndicator Enum value',
        },
        cmhcLoanAccountNumber: {
            type: 'number',
            minimum: 10000000,
            maximum: 99999999,
            errorMessage: 'Should be a numeric value with 8 digits',
        },
        exceptionToListing: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be between boolean or null',
        },
        partialPaymentReceived: {
            type: ['boolean', 'string'],
            errorMessage: 'Should be a boolean or string',
        },
        rentalIncomeReceived: {
            type: ['boolean', 'string'],
            errorMessage: 'Should be a boolean or string',
        },
        validationResult: {
            type: ['object', 'null'],
        },
        indicator: indicator_1.indicatorSchema,
        lender: lender_1.lenderSchema,
        borrowers: {
            type: 'array',
            items: borrower_details_1.borrowerDetailsSchema,
            maxItems: 10,
        },
        property: property_1.propertySchema,
        defaultManagement: default_management_1.defaultManagementSchema,
        detail: detail_1.detailSchema,
        listing: {
            type: 'array',
        },
        borrowerCharges: {
            type: 'array',
            items: borrower_charges_1.borrowerChargesSchema,
        },
        netOperatingIncomeRentalIncomes: {
            type: ['array', 'null'],
            items: net_operating_income_rental_income_1.netOperatingIncomeRentalIncomeSchema,
        },
        partialPayments: {
            type: ['array', 'null'],
            items: partial_payment_1.partialPaymentsSchema,
        },
    },
};
